<template lang="pug">
  v-form(ref="form-input-number" lazy-validation @submit.prevent="() => {}")
    // v-text-field(
      :id="id"
      :value="formattedValue"
      :label="label"
      :outlined="true"
      :readonly="readonly"
      :rules="inputRules"
      @change="(e) => onChangeValue(e)"
      @input="(e) => onInputValue(e)"
      @focus="(e) => onFocusInput(e)"
      @blur="(e) => onBlurInput(e)"
      @keydown="(e) => onKeydown(e)"
    // )
    v-text-field(
      :id="id"
      :value="formattedValue"
      :label="label"
      :outlined="true"
      :readonly="readonly"
      :rules="inputRules"
      :hide-details="hideDetails"
      @change="(e) => onChangeValue(e)"
      @keydown.stop.enter="onEnter"
      :placeholder="placeholder"
      :key="inputKey"
    )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
// import { roundNumber } from '@/utils/number'

import AutoNumeric from 'autonumeric'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  watch: {
    value () {
      this.numElement.set(this.value)
      this.inputKey++

      this.$nextTick(() => {
        this.formattedValue = this.numElement.getFormatted()
      })
    },
  },
})
export default class NNumberInput extends Vue {
  @Prop({ type: [ String, Number ], default: '' }) value
  @Prop({ type: [ String, Number ], default: '' }) id
  @Prop({ type: String, default: '' }) label
  @Prop({ type: String, default: '' }) type
  @Prop({ type: Number, default: 0 }) decimals
  @Prop({ type: Boolean, default: false }) disabled
  @Prop({ type: Boolean, default: false }) readonly
  @Prop({ type: Boolean, default: false }) hideThousandSeparator
  @Prop({ type: Array, default: () => [] }) inputRules
  @Prop({ type: Boolean, default: false }) hideDetails
  @Prop({ type: String, default: '' }) placeholder

  formattedValue = null
  numElement = null
  inputKey = 0

  defaultOptions = {
    digitGroupSeparator: '.',
    decimalCharacter: ',',
    decimalCharacterAlternative: '.',
    decimalPlaces: 999,
    currencySymbol: '',
    currencySymbolPlacement: 's',
    emptyInputBehavior: 'null',
    roundingMethod: 'U',
    minimumValue: '0'
  }

  get isCurrency () {
    return this.type === 'w' || this.type === 'W'
  }

  mounted () {
    const options = {
      ...this.defaultOptions,
      decimalPlaces: this.decimals,
      digitGroupSeparator: this.hideThousandSeparator ? '' : '.',
    }

    if (this.isCurrency) {
      options.currencySymbol = '\u202f€'
    }

    this.numElement = new AutoNumeric(`#${ this.id }`, options)
    this.numElement.set(this.value)

    this.$nextTick(() => {
      this.formattedValue = this.numElement.getFormatted()
    })
  }

  onChangeValue (e) {
    if (!this.isFormValid('form-input-number')) {
      return
    }

    if (e === '' || e === null) {
      this.$emit('input', null)
      this.$emit('change', null)
      return
    }

    this.numElement.set(e)

    const value = this.numElement.getNumber()

    this.$emit('input', value)
    this.$emit('change', value)
  }

  onEnter (e) {
    console.log('enter: ', e)
  }
}
</script>
